import { useEffect } from "react";
import { LuLoaderCircle } from "react-icons/lu";
import { LOCAL_STORAGE_KEYS } from "../../config/local_storage_keys";
import BlueWaveLayout from "../common_components/BlueWaveLayout";

export default function SubscriptionsFailurePage() {
  useEffect(() => {
    const returnUrl = localStorage.getItem(
      LOCAL_STORAGE_KEYS.SUBSCRIPTIONS_MODAL_RETURN_URL
    );
    localStorage.removeItem(LOCAL_STORAGE_KEYS.SUBSCRIPTIONS_MODAL_RETURN_URL);

    window.location.replace(returnUrl || "/");
  }, []);

  return (
    <BlueWaveLayout>
      <div className="flex flex-col items-center justify-center gap-4">
        <LuLoaderCircle size={56} className="animate-spin" />
        <p className="text-lg text-center">Returning back to the app...</p>
      </div>
    </BlueWaveLayout>
  );
}
